const removeDecimalWithoutRounding = (number: number, digits = 2) => {
  return (
    Math.trunc(number * Math.pow(10, digits)) / Math.pow(10, digits)
  ).toLocaleString("id");
};
export default removeDecimalWithoutRounding;
